var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isHaiXiaoUser)?_c('HaiXiaoBar'):_vm._e(),_vm._v(" "),(_vm.showEquityRecallBar)?_c('EquityRecallBar',{attrs:{"equity-recall-info":_vm.equityRecallInfo}}):_vm._e(),_vm._v(" "),(_vm.showBrandBar)?_c('BrandBar'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }